module.exports = function(data) {
var __t, __p = '';
__p += '<div class="headerBar"></div>\n<div id="page-content"></div>\n';
return __p
}